import styled from 'styled-components'

export const EcosystemTermsCheckboxContent = styled.div`
  display: flex;
  align-items: center;
  padding-top: 5px;
`

export const EcosystemTermsLink = styled.a`
  color: var(--primary);
  cursor: pointer;
  text-decoration: none;
`
